import { PageHero, SectionHead, Reveal } from "../components/Reveal";
import DivisionCards, { NextPaths } from "../components/DivisionCards";
import { OWN_FLEET } from "../data/site";
import useSeo from "../components/Seo";

export default function Fleet() {
  useSeo(
    "Fleet Ecosystem",
    "The Royal Mahaveer Roadlines Pvt Ltd fleet ecosystem — commercial goods & specialized transport, commercial & public transport, our real operations gallery and upcoming fleet."
  );
  return (
    <>
      <PageHero
        overline="Our Fleet Ecosystem"
        lines={[<>One company.</>, <>Five <em className="italic text-gold-light">divisions.</em></>]}
        desc="Our fleet ecosystem is organized into five divisions — goods & specialized, liquid, building & infrastructure, passenger transport and future mobility — supported by a living gallery of our real operations."
      />

      <section className="py-24 sm:py-32" data-testid="fleet-ecosystem-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <SectionHead
            overline="Choose a Division"
            title={<>The showroom, <em className="italic text-gold-light">organized</em></>}
            desc="Each division opens a digital showroom of its vehicle categories — our own fleet photographs are always marked OUR FLEET; illustrative images are always marked REPRESENTATIVE IMAGE."
          />
          <div className="mt-16">
            <DivisionCards />
          </div>
        </div>
      </section>

      <section className="border-t border-gold/10 bg-surface py-24 sm:py-32" data-testid="own-fleet-section">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <SectionHead
            overline="Verified Assets"
            title={<>Our own <em className="italic text-gold-light">fleet</em></>}
            desc="Vehicles and equipment owned and operated directly by The Royal Mahaveer Roadlines Pvt Ltd."
          />
          <div className="mt-14 grid gap-px border border-gold/15 bg-gold/15 sm:grid-cols-2 lg:grid-cols-3">
            {OWN_FLEET.map((f, i) => (
              <Reveal key={f.unit} delay={0.05 * i} className="h-full">
                <div className="flex h-full items-baseline gap-4 bg-ink p-6" data-testid={`own-fleet-${i}`}>
                  <span className="font-heading text-3xl text-gold">{f.qty}×</span>
                  <span className="text-sm leading-relaxed text-foreground/85">{f.unit}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <NextPaths exclude="/fleet" />
    </>
  );
}
